import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Handle stale chunk errors after deploy - auto reload once
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('Loading chunk') || 
      (e.message && e.message.includes("Unexpected token '<'"))) {
    const reloaded = sessionStorage.getItem('chunk_reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// PWA — Sessiz Stüdyo service worker registration.
// Production-only (development'ta CRA hot-reload'la çakışmaması için).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // Yeni SW algılanırsa: kullanıcı bir sonraki reload'da yeni asset'leri görür.
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Sessizce skip-waiting tetikle; controllerchange handler reload eder.
                newWorker.postMessage('SKIP_WAITING');
              }
            });
          }
        });
      })
      .catch(() => { /* SW kayıt hatası kullanıcı deneyimini bozmasın */ });

    // Yeni SW devreye girince TEK SEFER reload — eski JS chunk'larıyla çakışmasın.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
